/**
 * Address Review Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4021-78780
 */
import { Button } from '@components/ui/button';
import { Spinner } from '@components/ui/spinner';
import { InformationSection } from '@shared-web/components/InformationRow';

import { AddressValue } from '../AddressValue';

interface AddressReviewProps {
  isSubmitting: boolean;
  /**
   * Social Security Number (SSN)
   */
  ssn: string;

  /**
   * Residential address details
   */
  address: {
    streetAddress: string;
    apartment?: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
  };

  /**
   * Callback when Edit details button is clicked
   */
  onEdit: () => void;

  /**
   * Callback when Submit button is clicked
   */
  onSubmit: () => void;
}

export function AddressReview({
  isSubmitting,
  ssn,
  address,
  onEdit,
  onSubmit,
}: AddressReviewProps) {
  return (
    <div className="sm:w-[394px]">
      {/* Title */}
      <h2 className="text-foreground">Review and confirm</h2>

      {/* Information Section */}
      <InformationSection
        className="py-6"
        items={[
          {
            label: 'Social Security Number (SSN)',
            value: ssn,
          },
          {
            label: 'Residential address',
            value: (
              <AddressValue
                streetAddress={address.streetAddress}
                apartment={address.apartment}
                state={`${address.city}, ${address.state}`}
                country={address.country}
                zipCode={address.zipCode}
              />
            ),
          },
        ]}
      />

      {/* Action Buttons */}
      <div className="flex gap-4">
        <Button
          type="button"
          variant="secondary"
          onClick={onEdit}
          className="flex-1"
        >
          Edit details
        </Button>
        <Button
          disabled={isSubmitting}
          type="button"
          variant="primary"
          onClick={onSubmit}
          className="flex-1"
        >
          Submit {isSubmitting ? <Spinner className="ml-2 size-4" /> : ''}
        </Button>
      </div>
    </div>
  );
}
